import type { MonospaceFile } from '#layers/data-model/public';
import { joinURL } from 'ufo';

export interface GetAssetUrlOptions {
	apiBase: string;
	workspaceSlug?: string;
}

export function getAssetUrl(file: MonospaceFile, options: GetAssetUrlOptions): string;
export function getAssetUrl(assetId: string, options: GetAssetUrlOptions): string;
export function getAssetUrl(idOrFile: string | MonospaceFile, options: GetAssetUrlOptions): string;

export function getAssetUrl(idOrFile: string | MonospaceFile, options: GetAssetUrlOptions) {
	const { apiBase, workspaceSlug } = options;
	const assetId = typeof idOrFile === 'string' ? idOrFile : idOrFile.id;

	return joinURL(apiBase, workspaceSlug ?? 'system', 'assets', assetId);
}
